import { useState, useEffect } from "react"
import "./AdminErrorMessage.css"

function ErrorMessage({ error, setError }){
    const [ timeoutRef, setTimeoutRef ] = useState(setTimeout(() => null))
    const [ beginDisable,  setBeginDisable] = useState(false)
    
    useEffect(() => {
        setTimeoutRef(setTimeout(() => setError({ message: error.message, isActive: false }), 5000))
        setTimeout(() => setBeginDisable(true), 4500)

        return () => clearTimeout(timeoutRef)
    }, [ error ])

    return(
        <>
        <div className="black-background"></div>
        <div className='absolute-wrapper'>
            <div className={`error-wrapper ${beginDisable ? "disabled" : ""}`}>
                <h1>Erro</h1>
                <p>{error.message}</p>
                <button className={'close-button'} onClick={() => setError({ message: error.message, isActive: false })}></button>
            </div>
        </div>
        </>
    )
}

export default ErrorMessage